module.exports = __webpack_public_path__ + "static/media/FocusArea2-2019.2355bea7.png";